import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const UnpaidDividend = () => {
  const pageid = 13; // 🔑 set correct pageid for unpaid dividend
  const [dividends, setDividends] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDividends = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setDividends([]);
          return;
        }

        // Group by year_name
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name; // API should return year_name
          if (!grouped[year]) grouped[year] = [];
          grouped[year].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        // Convert grouped object to array + sort descending
        const finalData = Object.keys(grouped)
          .map((year) => ({
            year,
            reports: grouped[year],
          }))
          .sort((a, b) => parseInt(b.year) - parseInt(a.year));

        setDividends(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setDividends([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDividends();
  }, []);

  return (
    <>
      <Helmet>
        <title>Dividend | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full">
        <img
          src="./imgs/investors/investordividend.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 bg-black bg-opacity-10 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Dividend
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 max-w-7xl mx-auto font-signika">
        {loading ? (
          <p>Loading dividends...</p>
        ) : dividends.length === 0 ? (
          <p>No dividend reports found.</p>
        ) : (
          dividends.map((yearGroup, index) => (
            <div key={index} className="mb-10">
              <h2 className="text-2xl font-extrabold text-[#0b3a6a] uppercase mb-4">
                For the Year {yearGroup.year}
              </h2>
              {yearGroup.reports.length === 0 ? (
                <p>No reports available for this year.</p>
              ) : (
                <ul className="list-disc pl-5 text-[#0b3a6a] font-medium space-y-2">
                  {yearGroup.reports.map((report, idx) => (
                    <li key={idx}>
                      <a
                        href={report.file ? `${API_PDF_URL}/${report.file}` : "#"} // ✅ Use # if no PDF
                        target={report.file ? "_blank" : "_self"}
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        {report.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
              <hr className="mt-4 border-gray-300" />
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default UnpaidDividend;
